export const useStyles = () => ({
    root: {
        display: 'grid',
        gap: 2,
        gridTemplateColumns: 'repeat(3, 1fr)'
    },
    item: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 1,
        pl: 1,
        pr: 1,
        alignItems: 'center',
        whiteSpace: 'nowrap'
    }
});

export default useStyles;
